export const DevicesWidth = {
  mobile: '480px',
  tablet: '769px',
  desktop: '1025px'
}
